/* eslint-disable no-underscore-dangle */
/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

import Card from "@mui/material/Card";
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import CardTitle from "components/CardTitle";
import { useTranslation } from "react-i18next";
import Calendar from "components/Calendar";
import enLocale from "@fullcalendar/core/locales/en-gb";
import esLocale from "@fullcalendar/core/locales/es";
import amenityUtils from "../project/components/amenitiesConfig/amenityUtils";

function AmenityEventsCalendar({
  events,
  handleDateSelect,
  handleEventClick,
  amenity,
  initialDate,
}) {
  const { t, i18n } = useTranslation();

  const { addColorByStatusToEvents, renderEventContent, getAllowedMaxHourInCalendarView } =
    amenityUtils;

  const reservationName = amenity?.name;

  const allowedStart = amenity?.startTime;
  const reservationEndTime = amenity?.endTime;

  const durationTime = amenity?.amenityDuration;

  const allowedEnd = getAllowedMaxHourInCalendarView(durationTime);

  const daysOfWeekAllowed = amenity?.availableDays;

  const coloredEvents = addColorByStatusToEvents(events);

  return (
    <Card
      sx={{
        "& .fc .fc-timegrid-slot": {
          height: "3.25rem",
        },
      }}
    >
      <CardTitle
        title={`${t("amenity")} ${reservationName}`}
        icon="access_time"
        bgColor="warning"
      />
      <Calendar
        headerToolbar={{
          start: "today prev,next",
          center: "title",
          end: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        allDaySlot={false}
        expandRows={false}
        slotMinTime={`${allowedStart}:00`}
        slotMaxTime={`${allowedEnd}:00`}
        dayMaxEventRows={4}
        initialView="timeGridWeek"
        initialDate={initialDate}
        events={coloredEvents}
        eventContent={renderEventContent}
        locale={i18n.language === "es" ? esLocale : enLocale}
        contentHeight={750}
        height={750}
        selectable
        select={handleDateSelect}
        eventClick={handleEventClick}
        eventOverlap
        slotEventOverlap
        businessHours={{
          daysOfWeek: daysOfWeekAllowed,
          startTime: allowedStart,
          endTime: reservationEndTime,
        }}
        selectConstraint={{
          startTime: allowedStart,
          endTime: reservationEndTime,
        }}
      />
    </Card>
  );
}

AmenityEventsCalendar.defaultProps = {
  events: [],
  handleDateSelect: () => {},
  handleEventClick: () => {},
  amenity: {},
  initialDate: Date.now(),
};

AmenityEventsCalendar.propTypes = {
  events: PropTypes.array,
  handleDateSelect: PropTypes.func,
  handleEventClick: PropTypes.func,
  amenity: PropTypes.object,
  initialDate: PropTypes.any,
};

export default AmenityEventsCalendar;
